export const POPUP_CANCELLATION_POLICY_SHOWN = 'POPUP_CANCELLATION_POLICY_SHOWN';
export const POPUP_CANCELLATION_POLICY_SHOWN_VERSION = '1.0';

export type PopupCancellationPolicyShownPayload = {
  searchId: string;
  roomId: string;
  productDetailKey: string;
};

export type PopupCancellationPolicyShownParams = {
  searchId: string;
  roomId: string;
  productDetailKey: string;
};

export const createPopupCancellationPolicyShownPayload = ({
  searchId,
  roomId,
  productDetailKey,
}: PopupCancellationPolicyShownParams): PopupCancellationPolicyShownPayload => ({
  searchId,
  roomId,
  productDetailKey,
});
